<div class="col px-lg-5 px-2">
	<button
		type="button"
		class="btn theme-main-color-button"
		(click)="exportExcel()"
	>
		<i class="bi bi-download" aria-hidden="true"></i>
		Global
	</button>

	<div
		class="card-body text-center"
		*ngFor="let employeeReport of funderReport?.employeesReport"
	>
		<h3>
			<u>{{
				employeeReport.employee.firstName +
					' ' +
					employeeReport.employee.lastName
			}}</u>

			<button
				class="ms-3 btn theme-main-color-button"
				(click)="exportExcel(employeeReport.employee)"
			>
				<i class="bi bi-download" aria-hidden="true"></i>
			</button>
		</h3>
		<div class="table-responsive">
			<table
				class="table theme-main-color table-bordered table-hover mt-2"
				id="funderReportTable{{ employeeReport.employee.id }}"
			>
				<caption></caption>
				<thead class="table-light theme-main-color">
					<col />
					<col />
					<col />
					<col />
					<colgroup span="6" *ngFor="let funder of funders"></colgroup>
					<tr class="table-light theme-main-color">
						<th rowspan="2" class="manual-sticky" id="date">Date</th>
						<th rowspan="2" id="jour">Jour</th>
						<th rowspan="2" id="asc">A. S. Comm</th>
						<th rowspan="2" class="text-danger" id="abs">ABS</th>
						<th
							colspan="6"
							scope="colgroup"
							*ngFor="let funder of funders"
							class="border-0 border-start border-2 border-dark"
						>
							{{ funder.name }}
						</th>
					</tr>
					<tr>
						<ng-container *ngFor="let funder of funders">
							<th
								scope="col"
								class="text-primary border-0 border-start border-2 border-dark"
							>
								A.S.
							</th>
							<th scope="col" class="text-danger bg-danger bg-opacity-25">
								A.U.
							</th>
							<th scope="col" class="text-success">A.P.</th>
							<th scope="col" class="text-gold">TRAJ</th>
							<th scope="col" class="text-magenta">INTERV</th>
							<th scope="col">ABS</th>
						</ng-container>
					</tr>
				</thead>
				<tbody *ngFor="let dayReport of employeeReport.days; let i = index">
					<tr>
						<th scope="row" class="manual-sticky">
							{{ getDate(dayReport.date) }}
						</th>
						<td>{{ dayReport.labelDay }}</td>
						<th scope="row">
							{{ timeConvert(dayReport.adminServiceTime) }}
						</th>
						<td class="text-danger">
							{{ timeConvert(dayReport.absencesTime) }}
						</td>
						<ng-container *ngFor="let funder of funders">
							<td
								class="text-primary border-0 border-start border-2 border-dark"
							>
								{{
									timeConvert(
										getCorrespondingFunderReport(dayReport, funder.id)
											? getCorrespondingFunderReport(dayReport, funder.id)
													.adminServiceTime
											: 0
									)
								}}
							</td>
							<td class="text-danger bg-danger bg-opacity-25">
								{{
									timeConvert(
										getCorrespondingFunderReport(dayReport, funder.id)
											? getCorrespondingFunderReport(dayReport, funder.id)
													.adminUsagerTime
											: 0
									)
								}}
							</td>
							<td class="text-success">
								{{
									timeConvert(
										getCorrespondingFunderReport(dayReport, funder.id)
											? getCorrespondingFunderReport(dayReport, funder.id)
													.appuiProsTime
											: 0
									)
								}}
							</td>
							<td class="text-gold">
								{{
									timeConvert(
										getCorrespondingFunderReport(dayReport, funder.id)
											? getCorrespondingFunderReport(dayReport, funder.id)
													.travelTime
											: 0
									)
								}}
							</td>
							<td class="text-magenta">
								{{
									timeConvert(
										getCorrespondingFunderReport(dayReport, funder.id)
											? getCorrespondingFunderReport(dayReport, funder.id)
													.interventionTime
											: 0
									)
								}}
							</td>
							<td>
								{{
									timeConvert(
										getCorrespondingFunderReport(dayReport, funder.id)
											? getCorrespondingFunderReport(dayReport, funder.id)
													.absenceTime
											: 0
									)
								}}
							</td>
						</ng-container>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>
